import styled from 'styled-components';
import { IToken, ThemeList } from 'store/ducks/globalTypes';
import { variablesList } from 'constants/variablesList';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { IThemeSelectorProps } from 'store/ducks/Global/types';

interface SidebarProps {
  open: boolean;
}

interface OverlayProps {
  show: boolean;
}

// Mobile navbar breakpoint
const MOBILE_BREAKPOINT = '900px';

export const StyledNav = styled('div')<IToken>`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: ${(props) => `8px ${props.token.paddingLG}px 4px`};
  z-index: 800;
  pointer-events: none;
  min-height: 70px;

  > * {
    pointer-events: auto;
  }

  @media (max-width: 1024px) {
    padding: 8px 8px 4px;
    min-height: 56px;
    align-items: flex-start;
    padding-top: 8px;
  }

  /* Hide desktop nav on mobile */
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: none;
  }
`;

/* ---- Mobile Navbar ---- */
export const MobileNav = styled('div')<IToken>`
  display: none;
  pointer-events: auto;
  z-index: 800;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 0;
  }
`;

export const MobileNavTop = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  width: 100%;

  .logout-mobile {
    flex-shrink: 0;
  }

  @media (max-width: 768px) and (min-width: 481px) {
    padding-bottom: 0;
  }
`;

export const MobileNavTitle = styled('div')`
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 0 6px;
  min-width: 0;
  max-width: calc(100% - 160px);
  overflow: hidden;

  @media (max-width: 768px) and (min-width: 481px) {
    max-width: calc(100% - 200px);
    margin-top: -20px;
  }

  @media (max-width: 480px) {
    max-width: calc(100% - 130px);
    margin-top: 0;
  }

  @media (max-width: 380px) {
    max-width: calc(100% - 110px);
  }
`;

export const MobileNavDropdowns = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 16px 8px;
  align-items: flex-end;
  margin-top: 4px;

  @media (max-width: 768px) and (min-width: 481px) {
    margin-top: 0;
    gap: 4px;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    padding: 0 16px 6px;
  }

  @media (max-width: 480px) {
    margin-top: 4px;
  }
`;

export const StyledLogo = styled.img.attrs({
  src: require('../../assets/img/Auriscom logo.png'),
  alt: 'Auriscom Logo'
})`
  width: 130px;
  height: auto;
  object-fit: contain;

  @media (max-width: 1024px) and (min-width: 901px) {
    margin-top: -34px;
  }

  @media (max-width: 900px) {
    width: 70px;
  }

  @media (max-width: 480px) {
    width: 55px;
  }
`;

export const LogoLink = styled(Link)`
  pointer-events: none;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;
export const NavigationContainer = styled('div')`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-rows: auto auto;
  gap: 6px 12px;
  align-items: start;
  margin-top: 0;
  width: auto;

  @media (max-width: 1024px) {
    gap: 4px 8px;
  }
`;

export const DropdownContainer = styled('div')`
  margin-top: 0px;
  margin-left: 70px;
  flex-direction: column;
  display: flex;
  gap: 4px;
  position: relative;
  z-index: 1001;

  @media (max-width: 1200px) {
    gap: 3px;
    margin-left: 50px;
  }

  @media (max-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 3px;
    margin-top: 1px;
    margin-left: 40px;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
    gap: 2px;
    margin-left: 0;
  }
`;

export const ControlsContainer = styled('div')<{ isReportingScreen?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
`;

export const ChangeButton = styled('div')`
  text-align: end;

  a {
    // margin: 16px 16px 0 0;
    z-index: 1;
    // border: 1px solid black;
    color: black;
  }

  .ant-btn-variant-solid {
    margin: 0px 0px 0px 16px;
  }
`;

export const MainButtons = styled.div`
  display: contents;
`;

export const Sidebar = styled.div<SidebarProps>`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  background: white;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.2);
  padding: 20px;
  transition: transform 0.3s ease-in-out;
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
  z-index: 1000;
`;

export const Overlay = styled.div<OverlayProps>`
  display: ${({ show }) => (show ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
`;

export const SubtitleText = styled.p`
  font-size: 1rem;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.9);
  margin: 5px 0 0 0;
`;

export const AreaTitle = styled('div')<{ isAllocationPage?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 0;
  padding: 0 12px;
`;

export const TitleContainer = styled('div')<IThemeSelectorProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  overflow: visible;
  background: linear-gradient(
    90deg,
    ${(props) => {
      const theme = props.theme as ThemeList;
      const isDarkerFirst = [
        'darkUITheme',
        'lightUITheme',
        'pinkUITheme',
        'greenModeTheme',
        'bluishTheme'
      ].includes(theme);
      return isDarkerFirst
        ? variablesList[theme].buttonPrimaryBgHover
        : variablesList[theme].tabSelected;
    }},
    ${(props) => {
      const theme = props.theme as ThemeList;
      const isDarkerFirst = [
        'darkUITheme',
        'lightUITheme',
        'pinkUITheme',
        'greenModeTheme',
        'bluishTheme'
      ].includes(theme);
      return isDarkerFirst
        ? variablesList[theme].tabSelected
        : variablesList[theme].buttonPrimaryBgHover;
    }}
  );
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);

  @media (max-width: 1300px) {
    padding: 12px 16px;
  }

  @media (max-width: 1050px) {
    padding: 8px 12px;
  }

  @media (max-width: 1024px) and (min-width: 901px) {
    padding: 4px 13px;
  }

  @media (max-width: 900px) {
    padding: 4px 6px;
    align-items: center;
  }

  @media (max-width: 380px) {
    padding: 6px 10px;
  }
`;

export const DataEntryTitle = styled.span`
  margin: 0;
  font-weight: bold;
  display: block;
  font-size: 22px;
  white-space: nowrap;
  color: #fff;

  @media (max-width: 1500px) {
    font-size: 18px;
  }

  @media (max-width: 1200px) {
    font-size: 15px;
  }

  @media (max-width: 1050px) {
    font-size: 13px;
    white-space: normal;
    text-align: center;
  }

  @media (max-width: 1024px) and (min-width: 901px) {
    font-size: 19px;
    white-space: normal;
    text-align: center;
  }

  @media (max-width: 900px) {
    font-size: clamp(16px, 4vw, 22px);
    white-space: normal;
    text-align: center;
    line-height: 1.3;
    word-break: break-word;
  }

  @media (max-width: 768px) {
    font-size: clamp(10px, 3vw, 18px);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  @media (max-width: 480px) {
    font-size: clamp(16px, 4vw, 22px);
    display: block;
    -webkit-line-clamp: unset;
    overflow: visible;
  }

  @media (max-width: 380px) {
    font-size: clamp(16px, 4vw, 22px);
  }
`;

export const WorkingAreaButton = styled.div`
  display: flex;
  margin: 0 24px;
  justify-content: space-between;

  div {
    display: flex;
    gap: 15px;
    text-align: justify;
  }
`;

export const LogoutBtn = styled(Button)<{ token: any; isLogout?: boolean }>`
  background: ${({ token, isLogout }) =>
    isLogout ? token.colorError : token.colorPrimary};
  color: #fff;
  transition: background 0.3s ease;
  border: 1px solid
    ${({ token, isLogout }) =>
      isLogout ? token.colorError : token.colorPrimary} !important;
  margin-bottom: 0px;
  grid-row: 1 / 3;
  align-self: center;
  white-space: nowrap;
  height: auto !important;
  min-height: 32px;
  line-height: 1.3 !important;
  text-align: center;

  @media (max-width: 1300px) {
    font-size: 12px;
    padding: 2px 8px;
  }

  @media (max-width: 1024px) and (min-width: 901px) {
    font-size: 11px;
    padding: 2px 6px;
  }

  @media (max-width: 768px) and (min-width: 481px) {
    font-size: 12px;
    padding: 4px 8px;
    flex-shrink: 0;
    margin-top: -20px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    padding: 4px 8px;
    flex-shrink: 0;
    margin-top: 0;
  }

  &:hover {
    background: ${({ token, isLogout }) =>
      isLogout ? token.colorErrorHover : token.colorPrimaryHover} !important;
    color: #fff !important;
    border: 1px solid
      ${({ token, isLogout }) =>
        isLogout ? token.colorErrorHover : token.colorPrimaryHover} !important;
  }
`;
